import { useMemo } from 'react';
import { useFetchSettingsQuery, useFetchStoreCurrencyQuery } from '../settingsApi';

const DEFAULT_FEATURES = {
  modernCourseBuilder: true,
};

export const useSettings = (params, options = {}) => {
  return useFetchSettingsQuery(params, {
    ...options,
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      settings: data || {},
      isLoading,
      isError,
      error,
    }),
  });
};

export const useStoreCurrency = (params, options = {}) => {
  return useFetchStoreCurrencyQuery(params, {
    ...options,
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      storeCurrency: data || null,
      isLoading,
      isError,
      error,
    }),
  });
};

// Hook-based accessors (no selector files)
export const useCurrency = () => {
  const { storeCurrency } = useStoreCurrency();
  const { settings } = useSettings();
  return storeCurrency?.currency ?? settings?.currency;
};

export const useStoreId = () => {
  const { storeCurrency } = useStoreCurrency();
  return storeCurrency?.storeId ?? null;
};

export const useSettingsObject = () => {
  const { settings } = useSettings();
  return settings;
};

export const useStoreHideVAT = () => {
  const { settings } = useSettings();
  return settings?.hideVAT ?? false;
};

export const useFeatures = () => {
  const { settings } = useSettings();
  return useMemo(() => ({
    ...DEFAULT_FEATURES,
    ...(settings?.features ?? {}),
  }), [settings?.features]);
};

export const useZroom = () => {
  const { settings } = useSettings();
  return settings?.zroom ?? null;
};
